/**
 * Created by lu on 2017/7/22.
 */
var nb = require('../../nb');
var input = require('./Input');
module.exports =nb.define({
        view: {
            'class': ['input-wrap'],
            $html: [{
                'class': 'input',
                $type: input,
                $model: ''
            }, {
                'class': 'submit-icon',
                $html: {
                    tag:'img',
                    src:nb.bind('image')
                }
            }]
        },
        method: {
            init: function () {

            }
        }
    });


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/InputSubmit.js
// module id = 29
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32